export const openExternalLink = (url: string) => {
  if (!url) return;

  // Ensure it includes a protocol (http/https)
  const finalUrl = url.startsWith("http") ? url : `https://${url}`;

  window.open(finalUrl, "_blank", "noopener,noreferrer");
};